import { type CSSProperties, type LiHTMLAttributes } from 'react';

import { styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

type LinkListItemProps = LiHTMLAttributes<HTMLLIElement> & {
  height?: CSSProperties['height'];
  isDisabled: boolean;
};

export const LinkListItem = styled('li', {
  shouldForwardProp: removeTheseProps<LinkListItemProps>(
    'isDisabled',
    'height',
  ),
})<LinkListItemProps>(({ height = 40, isDisabled }) => ({
  margin: 0,
  padding: 0,
  width: '100%',
  height,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  opacity: isDisabled ? 0.5 : 1,
  pointerEvents: isDisabled ? 'none' : 'all',
}));
